import * as React from "react";
import { Event, Market } from "../../../../contracts";
import { SportConfig, CardPropsHandlers } from "../../../../typings";
import * as RenderMethods from "./RenderMethods";
import { BaseDict } from "../../dict";
import { observer } from "mobx-react";
import { getCountLinkParams, getCardDetailsParams } from "../../../../helpers";

/* istanbul ignore next */
export type EventCardProps = {
    event: Event,
    markets: Market[],
    isDesktop: boolean,
    classNames?: string,
    sport: SportConfig,
    handlers: CardPropsHandlers,
    isFavoritesEnabled: boolean,
    showMLTeamName: boolean,
    showHeadingNames: boolean,
    showLeagueInEventCard: boolean,
    dict: BaseDict,
    showOddBtns?: boolean
}
@observer
export class EventCard extends React.Component<EventCardProps, {}> {
    cardTypeClass: string
    buttonsHolderClass: string
    componentPrefix: string

    constructor(props) {
        super(props);

        this.cardTypeClass = "";
        this.buttonsHolderClass = "";
        this.componentPrefix = "ev-card";
    }

    renderEventCardDetails = RenderMethods.renderEventCardDetails;
    renderMarkets = RenderMethods.renderMarkets;
    renderMarketsCountLink = RenderMethods.renderMarketsCountLink;

    getCountLinkParams = getCountLinkParams;
    getCardDetailsParams = getCardDetailsParams;

    setClasses(props) {
        const liveClass = props.event.isLive ? "rj-ev-list__ev-card--live" : "rj-ev-list__ev-card--upcoming";
        const classNames = props.classNames || "";

        return `rj-ev-list__ev-card ${liveClass} ${this.cardTypeClass} ${classNames}`;
    }

    render() {
        return (
            <div className={this.setClasses(this.props)} data-uat={`div-ev-list-${this.componentPrefix}`}>
                {this.renderEventCardDetails(this.getCardDetailsParams(this.props),this.componentPrefix)}
                {this.renderMarkets(this.props, this.buttonsHolderClass, this.componentPrefix)}
                {this.renderMarketsCountLink(this.getCountLinkParams(this.props), this.componentPrefix)}
            </div>
        )
    }
}